import { CustomIcon } from '@/types/Icons/Icon.type';
import { KeyboardArrowRight } from '@mui/icons-material';
import { Button } from '@mui/material';
import { ComponentPropsWithoutRef, ReactNode, forwardRef } from 'react';

interface IProps extends ComponentPropsWithoutRef<typeof Button> {
  Icon: CustomIcon;
  label: string;
  iconProps: object;
  children: ReactNode;
}

const TabButton = forwardRef<HTMLButtonElement, IProps>(({ Icon, label, iconProps, children, ...props }, ref) => (
  <Button
    {...props}
    ref={ref}
    sx={{
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      padding: '10px 16px',
      height: '40px',
      fontWeight: 500,
      boxShadow: 'none',
    }}
  >
    <Icon className='w-[20px] h-[20px]' {...iconProps} />
    <span>{label}</span>
    <KeyboardArrowRight sx={{ marginLeft: 'auto', width: '14px', height: '14px' }} />
    {children}
  </Button>
));

export default TabButton;
